import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated Finances URLs.
 *
 * Kept separate from `finances.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const billsRoute = defineRoute("/bills");
export const createBillRoute = defineRoute(`${billsRoute.path}/:idOrAdd`);
export const invoicesRoute = defineRoute("/invoices");
export const purchaseOrdersRoute = defineRoute("/purchase-orders");
export const invoiceTermsRoute = defineRoute("/invoice-terms");
export const invoiceTermRoute = defineRoute(`${invoiceTermsRoute.path}/:idOrAdd`);
export const lienWaiversRoute = defineRoute("/lien-waivers");
